import { apiFuns } from "sw-hic"
let { genStandard, download } = apiFuns
const api = {
  Hospitalization: genStandard("hospitalization", "/api/ip", false),
  Attachment: genStandard("attachment", "/api/store"),
  getExcel: (url, para) => apiFuns.get(url, para),
  downloadExcel: (url) => download(url,{})
}
export default api;